<template>
  <div class="include_footer">
    <ul>
      <li v-for="(item,index) in footerTobarData"
        :key="index"
        :class="{liActive:isActive==index}"
        v-tap
        @tap="toLink(item.tobarLink,index)">
        <i class="icon iconfont"
          v-html="item.tobarIcon"></i><br>{{item.tobarContent}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "dyfooter",
  data() {
    return {
      footerTobarData: []
      // isActive: 0
    };
  },
  activated() {
    this.$store.commit("selectIndex", footerIndex);
    this.footerTobarData = this.getFooter();
  },
  methods: {
    getFooter() {
      console.log("getfooter");
      var arr = [
        {
          tobarLink: "/home/select",
          tobarIcon: "&#xe656",
          tobarContent: "自选"
        },
        {
          tobarLink: "/home/market",
          tobarIcon: "&#xe66d;",
          tobarContent: "行情"
        },
        {
          tobarLink: "/home/trade",
          tobarIcon: "&#xe6ba;",
          tobarContent: "交易"
        },
        {
          tobarLink: "/home/condition",
          tobarIcon: "&#xe60b;",
          tobarContent: "云条件单"
        },
        {
          tobarLink: "/home/search",
          tobarIcon: "&#xe603;",
          tobarContent: "搜索"
        }
      ];
      if (crmAddress) {
        arr.push({
          tobarLink: "/home/person",
          tobarIcon: "&#xe6b3;",
          tobarContent: "个人中心"
        });
      }
      return arr;
    },
    toLink(tobarLink, index) {
      footerIndex = index;
      this.$store.commit("selectIndex", index);
      // this.isActive = index;
      this.$router.push({
        path: tobarLink
      });
    }
  },
  computed: {
    isActive: function() {
      return this.$store.state.bottomIndex;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/zIndex.scss";

.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  /*color:#fff;*/
  color: #7d7d7d;
}

.include_footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: $footer;
  width: 100%;
  height: 1.1rem;
  /*background: #3C4041;*/
  background: #1f1f1f;
  /*border-top: 1px solid #dadadb;*/

  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}

.include_footer ul {
  font-size: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #7d7d7d;
}

.include_footer ul li {
  display: inline-block;
  font-size: 0.24rem;
  line-height: 0.3rem;
  /*color: #7d7d7d;*/
  flex: 1;
  text-align: center;
  padding-top: 0.18rem;
  /*background: red;*/
}

.include_footer ul li i {
  display: inline-block;
  padding-bottom: 0.1rem;
}

/*.include_footer ul li.check{*/
/*color: #ee3f44;*/
/*}*/

.include_footer ul li:active {
  /*color: red;*/
  /*color: #fff;*/
  /*color:greenyellow;*/
  /*color:green;*/
  /*color:#E8E8E8;*/
  /*color:#FD3712;*/
  /*color:#D9B672;*/
  color: #a57518;
}

.liActive {
  /*color: red;*/
  /*color: #fff;*/
  /*color:greenyellow;*/
  /*color:green;*/
  /*color:#E8E8E8;*/
  /*color:#FD3712;*/
  /*color:#D9B672;*/
  /*color:#A57518;*/
  color: #ee3f44;
}

.liActive i {
  /*color: red;*/
  /*color: #fff;*/
  /*color:greenyellow;*/
  /*color:green;*/
  /*color:#E8E8E8;*/
  /*color:#FD3712;*/
  /*color:#D9B672;*/
  /*color:#A57518;*/
  color: #ee3f44;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dyfooter.vue